/* lettra: gemeinsame Einpass-Logik für einzeilige Schriftzüge.
   Genutzt von lettra-hero.js (Signature-Animation) und lettra-configurator.js
   (Live-Vorschau) — bewusst EIN Pattern, nicht zwei.

   Aufgabe: Den Text so groß wie möglich setzen, ohne dass er aus seinem
   Container läuft, und dabei niemals umbrechen. Der Aufrufer sorgt für
   white-space: nowrap im CSS.

   Warum gemessen und nicht geschätzt: Zeichenzahl × Faktor geht bei
   Schreibschriften und bei Versalien systematisch daneben. Gemessen wird bei
   einer festen Referenzgröße, danach linear hochgerechnet — Breite und Höhe
   skalieren linear mit der Schriftgröße, ein Durchgang genügt. */
(function () {
  'use strict';

  /* Referenzgröße für die Messung — beliebig, nur groß genug für ein
     rundungsarmes Verhältnis. */
  var MEASURE_PX = 100;

  /* Ausdehnung des Textes messen.
     scrollWidth taugt dafür nicht: Der Schriftzug ist zentriert, ragt also nach
     beiden Seiten heraus, und scrollWidth zählt nur den Überhang rechts — die
     Zeile käme zu schmal heraus. Ein Range über den Inhalt liefert dagegen die
     tatsächliche Ausdehnung aller Buchstaben, inklusive Ober- und Unterlängen. */
  function textBox(el) {
    /* Gemessen wird das Element selbst, mit allem, was CSS ihm gibt — auch
       font-feature-settings ("calt" 0, "liga" 0 auf der Konfigurator-Vorschau,
       seit 1. 9. 2026). Hier ist deshalb nichts einzustellen; wer ein neues
       Element einpasst, setzt die Features am Element, nicht hier. */
    var range = document.createRange();
    range.selectNodeContents(el);
    var rect = range.getBoundingClientRect();
    return {
      width: rect.width || el.scrollWidth || 0,
      height: rect.height || el.offsetHeight || 0
    };
  }

  function innerBox(container) {
    var cs = window.getComputedStyle(container);
    return {
      width: container.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight),
      height: container.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom)
    };
  }

  /* @param {HTMLElement} el        Das Textelement
     @param {HTMLElement} container Die Fläche, in die es passen muss
     @param {object} [opts]
       opts.min  Untergrenze der Schriftgröße in px (Standard 18)
       opts.max  Obergrenze in px — im Konfigurator die maßstabsgetreue Größe
       opts.fitHeight  false schaltet die Höhenbegrenzung ab (Standard true) */
  function fitText(el, container, opts) {
    if (!el || !container || !el.textContent) return;
    opts = opts || {};
    var min = typeof opts.min === 'number' ? opts.min : 18;
    var max = typeof opts.max === 'number' ? opts.max : 220;

    var avail = innerBox(container);
    if (!(avail.width > 0)) return;

    /* Messen mit ausgesetzter Transition und ohne Skalierung.
       Auf der Konfigurator-Vorschau liegt eine font-size-Transition — ein
       getBoundingClientRect direkt nach dem Setzen läse sonst den alten,
       gerade weganimierten Wert. Die vorherige Größe wird zwischengespeichert
       und wiederhergestellt, damit die Transition am Ende von der echten
       Ausgangsgröße animiert und nicht von der Referenzgröße. */
    var prevTransition = el.style.transition;
    var prevSize = el.style.fontSize;
    el.style.transition = 'none';
    el.style.transform = 'none';
    el.style.fontSize = MEASURE_PX + 'px';
    void el.offsetWidth;
    var box = textBox(el);
    el.style.fontSize = prevSize;
    void el.offsetWidth;

    if (!(box.width > 0)) {
      el.style.transition = prevTransition;
      return;
    }

    var byWidth = (MEASURE_PX * avail.width) / box.width;
    var byHeight = Infinity;
    if (opts.fitHeight !== false && box.height > 0 && avail.height > 0) {
      byHeight = (MEASURE_PX * avail.height) / box.height;
    }

    var wanted = Math.min(max, byWidth, byHeight);
    var size = Math.max(min, wanted);

    /* Unterhalb der Untergrenze wird nicht weiter verkleinert, sondern
       horizontal gestaucht. Umbrechen ist keine Option: Die Meta-Zeile sagt
       „maßstabsgetreu simuliert" — zwei Zeilen würden diese Aussage widerlegen. */
    var rendered = (box.width * size) / MEASURE_PX;
    var scaleX = rendered > avail.width ? avail.width / rendered : 1;

    el.style.transition = prevTransition;
    el.style.fontSize = size + 'px';
    el.style.transform = scaleX < 1 ? 'scaleX(' + scaleX.toFixed(4) + ')' : '';
  }

  /* Neu einpassen, wenn sich die Fläche ändert (Drehen, Fensterbreite,
     Adressleiste auf iOS). ResizeObserver deckt auch Layoutwechsel ab, die
     kein resize-Event auslösen. */
  function observe(container, run) {
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { run(); });
      ro.observe(container);
      return;
    }
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
    window.addEventListener('orientationchange', run);
  }

  /* Erst messen, wenn die Displayschrift wirklich da ist. Die Ersatzschrift
     baut schmaler; wer vorher misst, friert eine zu große Größe ein. */
  function afterFonts(run) {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run, run);
    }
  }

  window.lettraFit = fitText;
  window.lettraFitObserve = observe;
  window.lettraFitAfterFonts = afterFonts;
  window.lettraFitMeasurePx = MEASURE_PX;
})();
